import { SiteId } from 'wly-ecommerce-common';
import { NotificationTypes } from '@src/global/components/Notification';
import { SubscriptionButton } from './SubscriptionButton';
import { VitalSourceButton } from './VitalSourceButton';
import { SubscriptionSiteId } from '@src/global/types/types';

interface AccessSubscriptionButtonProps {
  subscriptionUid: string;
  wSiteId: SubscriptionSiteId;
  setShowNotification: (arg: [NotificationTypes, string]) => void;
}

export const AccessSubscriptionButton = ({
  setShowNotification,
  subscriptionUid,
  wSiteId,
}: AccessSubscriptionButtonProps) => {
  const onClick = () => {
    window.open(
      process.env[`REACT_APP_${wSiteId.toUpperCase()}_HOST_URL`],
      '_blank'
    );
  };

  const button = {
    [SiteId.AGS]: <SubscriptionButton onClick={onClick} />,
    [SiteId.VET]: <SubscriptionButton onClick={onClick} />,
    [SiteId.COD]: (
      <VitalSourceButton
        setShowNotification={setShowNotification}
        subscriptionUid={subscriptionUid}
      />
    ),
    [SiteId.SPECTRABASE]: <SubscriptionButton onClick={onClick} />,
  };

  return <>{button[wSiteId]}</>;
};
